module.exports = __webpack_public_path__ + "static/media/tasks.b4c7bd1b.svg";